import ReactDOM from 'react-dom/client';
import './index.css';
//import './faroConsoleOverride';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from 'react-router-dom';
import { createReactRouterV6Options, FetchTransport, getWebInstrumentations, initializeFaro, LogLevel, ReactIntegration } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
export const REACT_APP_NAME: string = process.env.REACT_APP_NAME ?? '';
export const REACT_APP_GRAFANA_URL: string = process.env.REACT_APP_GRAFANA_URL ?? '';


// Initialize Faro (guarded so initialization errors won't crash startup)
const isValidFaroConfig = (): boolean =>
    REACT_APP_NAME.startsWith('ICMST-') && /^https:\/\//.test(REACT_APP_GRAFANA_URL);

(async function initFaro() {
    if (!isValidFaroConfig()) {
        console.warn('Faro not initialized: REACT_APP_NAME and REACT_APP_GRAFANA_URL must be set');
        return;
    }

    try {
        // Lazy-load Faro libraries so they don't bloat the main bundle when disabled
        const [{ initializeFaro, getWebInstrumentations, ReactIntegration, createReactRouterV6Options }, { TracingInstrumentation }] =
            await Promise.all([
                import('@grafana/faro-react'),
                import('@grafana/faro-web-tracing'),
            ]);

        const appVersion = process.env.REACT_APP_VERSION ?? '1.0.0';

        initializeFaro({
            url: REACT_APP_GRAFANA_URL,
            app: {
                name: REACT_APP_NAME,
                version: appVersion,
                environment: process.env.NODE_ENV ?? 'production',
            },
            instrumentations: [
                ...getWebInstrumentations({ captureConsole: true }),
                new TracingInstrumentation(),
                new ReactIntegration({
                    router: createReactRouterV6Options({
                        createRoutesFromChildren,
                        matchRoutes,
                        Routes,
                        useLocation,
                        useNavigationType,
                    }),
                }),
            ],
            consoleInstrumentation: {
                consoleErrorAsLog: true,
            },
        });
    } catch (e) {
        // Log the error and continue — avoids failing the whole app if Faro misconfigures
        console.error('Faro initialization failed:', e);
    }
})();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <App />
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
